import { ILand } from "src/modules/pe-fest-module/data/interfaces"
import Moment from "react-moment"

interface IProps {
    item: ILand
    className?: string
}
const DateLabel = (props: IProps) : JSX.Element => { 
    return  <div className={`${props.className}  d-flex`}>
        {
            !!props.item.startDate &&  <SingleDateLabel date={parseInt(props.item.startDate || "0")}/> 
        }
        {
            !!props.item.finishDate &&  <SingleDateLabel date={parseInt(props.item.finishDate || "0")} />  
        } 
    </div> 
} 
export default DateLabel

export const SingleDateLabel = (props:any) : JSX.Element => {
    return <div  className="date-label m-1">
        <div className="date-month-label">
            <i className="far fa-clock mr-2 hidden"></i> 
            <Moment locale="ru" format="MMMM" >
                {new Date(props.date * 1000)}
            </Moment> 
        </div>
        <div className="date-day-label">
            <Moment locale="ru" format="DD" >
                {new Date(props.date * 1000)}
            </Moment> 
        </div>
        <div className="date-year-label">
            <Moment locale="ru" format="YYYY" >
                {new Date(props.date * 1000)}
            </Moment> 
        </div> 
    </div> 
}